module.exports = __webpack_public_path__ + "3ae682f290f1c39b53681181c90478bb.png";